<template>
  <section>
    <!-- /////////////// WRAPPER -->
    <div>
      <!-- //CONTENT -->
      <div class="content__browse" style="overflow: scroll; height: 90vh; padding-bottom: 100px;">
        <div class="desktop">
          <b-row>
            <b-col sm="6">
              <h1 class="desktop">Parcourir</h1>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <div class="d-flex justify-content-between align-items-baseline w-100">
                <div class="d-flex align-items-baseline">
                  <div class="d-flex align-items-baseline mr-4" v-if="commercials && commercials.length > 0">
                    <p class="mr-2"><b>Commerciaux</b></p>
                    <v-select label="fullName" v-model='selectedCommercial' class="select" :options="commercials" placeholder="Rechercher..." style="min-width: 200px"></v-select>
                  </div>
                  <div v-if="codePtf && codePtf.length > 0" class="d-flex align-items-baseline">
                    <p class="mr-2"><b>Code portefeuille</b></p>
                    <div class="select__wrapper">
                      <font-awesome-icon :icon="['far', 'chevron-down']" />
                      <b-form-select v-model="selected" :options="codePtf" class="select" />
                    </div>
                  </div>
                  <div v-if="codePtfList && codePtfList.length > 0" class="d-flex align-items-baseline">
                    <p class="mr-2"><b>Code portefeuille</b></p>
                    <div class="select__wrapper">
                      <font-awesome-icon :icon="['far', 'chevron-down']" />
                      <b-form-select v-model="selectedCodePtf" :options="codePtfList" class="select" />
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-baseline">
                  <a
                      v-if="downloadDicoLink"
                      :href="downloadDicoLink"
                      target="_blank"
                      class="bt text-primary text-bold"
                  >
                    <i class="mr-2 fas fa-download"></i> <b>Dictionnaire</b>
                  </a>
                  <div class="d-flex align-items-baseline ml-5" v-if="dates && dates.length > 0">
                    <p class="mr-2"><b>Date fichier</b></p>
                    <div class="select__wrapper">
                      <font-awesome-icon :icon="['far', 'chevron-down']" />
                      <b-form-select :options="dates" v-model="selectedDateId" class="select" />
                    </div>
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>

        <div class="mobile">
          <b-row>
            <b-col sm="12">
              <h1 class="pl-0">Parcourir</h1>
            </b-col>
            <b-col sm="12" class="d-flex justify-content-start">
              <div class="d-flex">
                <div class="mb-3 mr-3" v-if="dates && dates.length > 0">
                  <div class="select__wrapper">
                    <font-awesome-icon :icon="['far', 'chevron-down']" />
                    <b-form-select :options="dates" v-model="selectedDateId" class="select" />
                  </div>
                </div>
                <div v-if="codePtf && codePtf.length > 0">
                  <div class="select__wrapper">
                    <font-awesome-icon :icon="['far', 'chevron-down']" />
                    <b-form-select v-model="selected" :options="codePtf" class="select" />
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="pb-2">
              <a
                  v-if="downloadDicoLink"
                  :href="downloadDicoLink"
                  target="_blank"
                  class="bt text-primary text-bold d-flex justify-content-end"
              >
                Télécharger le dictionnaire de données <i class="ml-3 fas fa-download"></i>
              </a>
            </b-col>
          </b-row>
        </div>

        <div>
          <!-- NATIONAL -->
          <section v-if="haveAccess(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL)">
            <b-row>
              <b-col sm="12">
                <Stack height="1.5rem" class="mobile" />
                <b-row class="d-flex ion-align-items-baseline mt-4 mb-3">
                  <b-col sm="12" class="d-flex align-items-baseline justify-content-start">
                    <div class="subHeader mb-2">
                      <div class="title">Indicateur de suivi national</div>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="bg-white card-big personal-indicator-part m-0 p-0 mt-3" v-if="personalIndicators && personalIndicators.national && personalIndicators.national.total && !isLoading">
                  <IndicatorsTreeTable
                      :tree="nationalTree"
                      v-model="checkIndicators"
                      :showCheckboxes="false"
                      @show-graph="showGraphModal"
                  />
                </b-row>

                <PuSkeleton :loading="isLoading" :count="4" width="100%" v-if="isLoading"/>
                <b-row class="bg-white card-big m-1 p-5 no-indicator" v-if="!isLoading && (!personalIndicators || !personalIndicators.national || personalIndicators.national.length === 0)">
                  <b-col sm="12" class="d-flex justify-content-between align-items-center no-indicator flex-column">
                    <i class="far fa-chart-line"></i>
                    <h1>Aucun indicateur de suivi national</h1>
                  </b-col>
                </b-row>

              </b-col>
            </b-row>
          </section>

          <!-- PERSONAL -->
          <section v-if="haveAccess(ApplicationsAccessEnum.APP_PARCOURIR)">
            <b-row>
              <b-col sm="12">
                <Stack height="1.5rem" class="mobile" />
                <b-row class="d-flex ion-align-items-baseline mt-4 mb-3">
                  <b-col sm="6" class="d-flex align-items-baseline">
                    <div class="subHeader mb-2">
                      <div class="title">Vos indicateurs de suivi</div>
                    </div>
                    <b-button
                        v-if="checkIndicators.length > 0"
                        class="bt-red pb-2 pt-2 ml-3"
                        @click="deleteCheckIndicators()"
                        ref="btnShow"
                    >
                      Supprimer
                    </b-button>
                  </b-col>
                  <b-col sm="6" class="d-flex justify-content-end">
                    <b-button class="bt-challenges pb-2 pt-2" @click="showModal" ref="btnShow">
                      Ajouter un indicateur
                    </b-button>
                  </b-col>
                </b-row>

                <b-row v-if="isLoading">
                  <b-col sm="12">
                    <PuSkeleton :loading="isLoading" :count="4" width="100%" />
                  </b-col>
                </b-row>

                <b-row
                    class="bg-white card-big m-1 p-5 no-indicator"
                    v-if="!isLoading && (!personalIndicators || !personalIndicators.personal || personalIndicators.personal.length === 0)"
                >
                  <b-col sm="12" class="d-flex justify-content-between align-items-center no-indicator flex-column">
                    <i class="far fa-chart-line"></i>
                    <h1>Aucun indicateur suivis</h1>
                    <h2>Parcourez vos indicateurs et suivez vos chiffres</h2>
                    <b-button class="bt-challenges pb-2 pt-2" @click="showModal" ref="btnShow">
                      Ajouter un indicateur
                    </b-button>
                  </b-col>
                </b-row>

                <b-row
                    class="bg-white card-big personal-indicator-part m-0 p-0 mt-3"
                    v-if="!isLoading && personalIndicators && personalIndicators.personal && personalIndicators.personal.total"
                >
                  <IndicatorsTreeTable
                      :tree="personalTree"
                      v-model="checkIndicators"
                      :showCheckboxes="true"
                      @show-graph="showGraphModal"
                  />
                </b-row>
              </b-col>
            </b-row>
          </section>
        </div>

        <Stack v-if="isMobile" />
      </div>

      <form-add-indicator @addIndicator="addIndicator" />
      <graph-modal />

      <!-- //CONTENT -->
    </div>
    <!-- /////////////// WRAPPER -->

    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->
    <transition name="slide">
      <keep-alive>
        <router-view class="transition"></router-view>
      </keep-alive>
    </transition>
    <!-- /////////////// ROUTER VIEW -> FIRST CHILD -->

    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
    <transition name="modal">
      <keep-alive>
        <router-view name="helper" class="myModal"></router-view>
      </keep-alive>
    </transition>
    <!-- /////////////// ROUTER VIEW -> MODAL = CHILDS -->
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import ParentMixin from '../../ParentMixin'
import CatMixin from '../../category/CatMixin'
import Stack from '../../../module/stack/Stack'
import ApiService from '../../../../services/ApiService'
import FormAddIndicator from '@/components/module/modal/FormAddIndicator.vue'
import ApiAuthenticationService from '@/services/ApiAuthenticationService'
import moment from 'moment'
import { ApplicationsAccessEnum } from '@/services/Enum/ApplicationsAccessEnum'
import GraphModal from '@/components/module/modal/GraphModal.vue'
import IndicatorsTreeTable from '@/components/module/tabs/IndicatorsTreeTable.vue'

export default {
  name: 'browseHome',
  components: {
    IndicatorsTreeTable,
    GraphModal,
    FormAddIndicator,
    Stack,
  },
  mixins: [ParentMixin, CatMixin],
  computed: {
    ApplicationsAccessEnum() {
      return ApplicationsAccessEnum;
    },
    moment() {
      return moment;
    },
    applicationsAccessList() {
      const aa = this.currentUser?.applicationsAccess;
      if (!aa) {
        return [];
      }
      return Array.isArray(aa) ? aa : Object.values(aa);
    },

    nationalTree() {
      return this.buildTree('national');
    },
    personalTree() {
      return this.buildTree('personal');
    },

    ...mapGetters(['getCurrentCodePtf', 'getCodePtf']),
  },
  data() {
    return {
      isLoading: true,
      codePtf: [],
      selected: null,
      dates: [],
      selectedDateId: null,
      selectedDate: null,

      personalIndicators: null,
      checkIndicators: [],

      downloadDicoLink: null,
      currentUser: {},

      commercials: [],
      selectedCommercial: null,
      selectedCodePtf: null,
      codePtfList: [],
    }
  },
  mounted() {
    this.$store.dispatch('showHeader', true);
  },
  created() {
    this.isLoading = true;
    this.codePtf = this.getCodePtf;
    this.currentUser = ApiAuthenticationService.getCurrentUser();

    if (this.codePtf?.length > 0) {
      if (this.getCurrentCodePtf == null) {
        this.selected = this.codePtf[0];
        this.$store.dispatch('setCurrentCodePtf', this.selected);
      } else if (this.codePtf.includes(this.getCurrentCodePtf)) {
        this.selected = this.getCurrentCodePtf;
        this.$store.dispatch('setCurrentCodePtf', this.selected);
      } else {
        this.selected = this.codePtf[0];
        this.$store.dispatch('setCurrentCodePtf', this.selected);
      }
    } else {
      this.$store.dispatch('setCurrentCodePtf', null);
    }

    ApiService.getParcourirApi()
        .getDates()
        .then((data) => {
          this.dates = (data.data || []).map((element) => ({
            value: element.id,
            text: element.text,
            date: element.value,
          }));

          if (this.dates.length > 0) {
            this.selectedDateId = this.dates[0].value;
            this.selectedDate = this.dates[0].date;
          }

          this.getData().then(() => {
            this.isLoading = false;
          })
        })

    ApiService.getCommercialApi()
        .getCommercialsList(ApiAuthenticationService.getCurrentUser().id, 'TOUS')
        .then(
            (data) => {
              this.commercials = data.data;
            },
            () => {}
        )
  },
  methods: {
    haveAccess(accessType) {
      return this.applicationsAccessList.includes(accessType);
    },

    async getData() {
      this.downloadDicoLink = ApiService.getMediaApi().getDico();

      const hasAccess =
          this.applicationsAccessList.includes(ApplicationsAccessEnum.APP_PARCOURIR) ||
          this.applicationsAccessList.includes(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL);

      if (!hasAccess) {
        return;
      }

      await ApiService.getParcourirApi()
          .getPersonalMonitoringResult(this.selectedCommercial?.id ?? ApiAuthenticationService.getCurrentUser().id, this.selectedDateId)
          .then(
              (data) => {
                this.personalIndicators = data.data;
              },
              () => {}
          )
    },

    addIndicator() {
      this.isLoading = true;
      ApiAuthenticationService.reloadUser()
          .then((response) => {
            this.currentUser = response.data;
            return this.getData();
          })
          .catch((err) => {
            console.error("Erreur lors de l'ajout:", err);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },

    async deleteCheckIndicators() {
      try {
        // 1. Extraire uniquement les clés (keys) des IDs sélectionnés
        // On transforme "personal_crit_123" -> "123"
        const keysToRemove = this.checkIndicators.map(id => {
          if (typeof id === 'string' && id.includes('_crit_')) {
            return id.split('_crit_')[1];
          }
          return id;
        });

        // 2. Créer un NOUVEAU tableau filtré (ne pas utiliser splice sur l'original)
        const updatedCriterias = this.currentUser.criterias.filter(val => {
          const criteriaKey = val.split(';')[0];
          return !keysToRemove.includes(criteriaKey);
        });

        // 3. Préparer un payload propre (on ne modifie pas l'objet currentUser directement)
        const payload = {
          ...this.currentUser,
          criterias: updatedCriterias
        };

        // 4. Envoyer la mise à jour
        await ApiService.getProfilApi().patch(this.currentUser.id, payload);

        // 5. Recharger les données
        await ApiAuthenticationService.reloadUser();
        this.checkIndicators = [];
        this.isLoading = true;
        await this.getData();
      } catch (error) {
        console.error("Erreur lors de la suppression:", error);
      } finally {
        this.isLoading = false;
      }
    },

    showGraphModal(data) {
      this.$store.dispatch('setGraphCriteria', {
        key: data.critere.key,
        name: data.critere.label,
        userId: data.objectData?.id,
        userName: data.objectData?.name,
        codePtf: data.objectData?.codePtf
      });
      this.$root.$emit('bv::show::modal', 'graph-modal', '#btnShow');
    },

    showModal() {
      ApiAuthenticationService.reloadUser().then(() => {
        this.$store.dispatch('setIndicatorUpdated', {
          mode: 'create',
          action: 'Créer',
          cancel: true,
          user: ApiAuthenticationService.getCurrentUser(),
        });

        this.$root.$emit('bv::show::modal', 'form-add-indicator', '#btnShow');
      })
    },

    buildTree(scope) {
      const raw = this.personalIndicators;
      if (!raw || !raw.infos){
        return [];
      }

      const infos = raw.infos || {};

      let total = (raw[scope] && raw[scope].total) ? raw[scope].total : {};

      //si on est un commercial ayant sélectionné un commercial on a des codes ptf maintenant
      if (this.selectedCodePtf) {
        total = (raw[scope] && raw[scope]?.[this.selectedCodePtf]) ? raw[scope][this.selectedCodePtf] : {};
      }

      //si on est un agent et qu'on a sélectionné un code ptf
      if (this.selected && raw[scope] && raw[scope][this.selected]) {
        total = raw[scope][this.selected];
      }

      const parents = new Map();

      Object.entries(infos).forEach(([criteriaKey, meta]) => {
        const parentLabel = meta.parentCategory || 'Autres';
        const categoryLabel = meta.category || 'Sans catégorie';

        const values = this.extractABC(total, criteriaKey);
        if (!values) {
          return
        }

        const parentNode = this.getOrCreateParent(parents, parentLabel);

        parentNode.children.push({
          id: `${scope}_crit_${criteriaKey}`,
          category: categoryLabel,
          key: criteriaKey,
          label: meta.label || criteriaKey,
          reverse: !!meta.reverse,
          refreshFrequency: meta.refreshFrequency,
          rank: meta.rank?.[this.selected] ?? meta.rank?.[this.selectedCodePtf] ?? meta.rank,

          moisN: values.c != null ? Math.round(Number(values.c)).toLocaleString() : '-',
          moisN1: values.b != null ? Math.round(Number(values.b)).toLocaleString() : '-',
          diff: values.diff != null ? Math.round(Number(values.diff)).toLocaleString() : '-',
          diffRaw: values.diff,

          nationalValue: meta.nationalValue ? Math.round(Number(meta.nationalValue)).toLocaleString() : '-',
          totalN1: values.a != null ? Math.round(Number(values.a)).toLocaleString() : '-',

          classement: raw?.classement?.[criteriaKey]?.[`${criteriaKey}_c`] ?? [],
        });
      });

      const sortByLabel = (a, b) => (a.label || '').localeCompare(b.label || '', 'fr', { sensitivity: 'base' });
      const sortByCategoryAndLabel = (a, b) => {
        const catA = (a.category || '').trim();
        const catB = (b.category || '').trim();

        const byCategory = catA.localeCompare(catB, 'fr', { sensitivity: 'base' });
        if (byCategory !== 0) {
          return byCategory;
        }

        const labelA = (a.label || '').trim();
        const labelB = (b.label || '').trim();

        return labelA.localeCompare(labelB, 'fr', { sensitivity: 'base' });
      }

      const result = Array.from(parents.values()).sort(sortByLabel);
      result.forEach((p) => p.children.sort(sortByCategoryAndLabel));
      return result;
    },

    getOrCreateParent(parents, parentLabel) {
      if (!parents.has(parentLabel)) {
        parents.set(parentLabel, {
          id: `parent:${parentLabel}`,
          label: parentLabel,
          isSection: true,
          children: [],
        });
      }
      return parents.get(parentLabel);
    },

    extractABC(obj, baseKey) {
      const row = obj && obj[baseKey] ? obj[baseKey] : null;
      if (!row) {
        return null;
      }

      const keyA = baseKey + '_a';
      const keyB = baseKey + '_b';
      const keyC = baseKey + '_c';

      return {
        a: row[keyA] ?? null,
        b: row[keyB] ?? null,
        c: row[keyC] ?? null,
        diff: row.diff ?? null,
      }
    },
  },
  watch: {
    selected() {
      this.$store.dispatch('setCurrentCodePtf', this.selected);
      this.isLoading = true;
      this.getData().then(() => {
        this.isLoading = false;
      })
    },
    selectedDateId() {
      this.isLoading = true;
      this.dates.forEach((date) => {
        if (date.value === this.selectedDateId) {
          this.selectedDate = date.date;
        }
      })
      this.getData().then(() => {
        this.isLoading = false;
      })
    },
    $route() {
      if (this.isMobile) {
        if (this.$route.path.includes('/parcourir/criteria/')) {
          this.$store.dispatch('showHeader', false);
        } else {
          this.$store.dispatch('showHeader', true);
        }
      }
    },
    selectedCommercial() {
      this.selectedCodePtf = null
      this.codePtfList = [];
      this.isLoading = true;
      this.getData().then(() => {
        this.isLoading = false;
      })
    },
    selectedCodePtf() {
      this.isLoading = true;
      this.getData().then(() => {
        this.isLoading = false;
      })
    },
    personalIndicators: {
      immediate: true,
      handler(raw) {
        if (this.codePtf && this.codePtf.length > 0) {
          return;
        }

        const list = raw?.['national']
            ? Object.keys(raw['national']).filter(k => k !== 'average' && k !== 'total')
            : [];

        this.codePtfList = list;

        if (list.length > 0 && !this.selectedCodePtf) {
          this.selectedCodePtf = list[0];
        }
      }
    }
  },
}
</script>